import * as React from 'react'
import moment from 'moment'

import { PeriodSelection } from '@/app/models/periodSelection'

import { useScene } from '../context/SceneContext'
import { useTimelineData } from '../context/DataContext'
import { useConfig } from '../context/ConfigContext'
import { PeriodSelectionBlock } from '../blocks/PeriodSelectionBlock'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

const PeriodSelectionsLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const scene = useScene()
  const { periodSelections } = useTimelineData()
  const { onPeriodSelectionsChanged } = useConfig()

  const [selections, setSelections] = React.useState<Array<PeriodSelection>>(
    () => [...(periodSelections || [])],
  )

  React.useEffect(() => {
    setSelections([...(periodSelections || [])])
  }, [periodSelections])

  const filtered = React.useMemo(() => {
    const result: Array<PeriodSelection> = []
    const startTime = scene.startTime
    const endTime = scene.startTime.clone().add(scene.days ?? 1, 'days')
    for (const item of selections) {
      const eventTime = moment(item.time)
      if (eventTime < startTime || eventTime > endTime) continue
      result.push(item)
    }
    return result
  }, [selections, scene])

  const handleSelected = React.useCallback(
    (selection: PeriodSelection) => {
      const next = selections.map((current) =>
        current.id === selection.id
          ? { ...selection, active: true }
          : { ...current, active: false },
      )
      setSelections(next)
      onPeriodSelectionsChanged && onPeriodSelectionsChanged(next)
    },
    [selections, onPeriodSelectionsChanged],
  )

  return (
    <LayerWrapper zIndex={zIndex}>
      {filtered.map((selection, index) => (
        <PeriodSelectionBlock
          key={index}
          selection={selection}
          index={index}
          onSelected={handleSelected}
        />
      ))}
    </LayerWrapper>
  )
}

export default PeriodSelectionsLayer
